import { isArray1hxjqtqy632bc as isArray } from '../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asNodeArrayOrNull(_this__u8e3s4) {
  // Inline function 'js.reflect.upcast' call
  var tmp = _this__u8e3s4;
  return isArray(tmp) ? tmp : null;
}
//region block: exports
export {
  asNodeArrayOrNull as asNodeArrayOrNull1w9l3ncxhchp6,
};
//endregion

//# sourceMappingURL=ReactNode.mjs.map
